module.exports = __webpack_public_path__ + "img/bkt-sport.36b9fd38.png";